import Chart from 'chart.js/auto';
import OeeCalculator from './oee-calculator.js';
import ProfitCalculator from './profit-calculator.js';

import donutSvg from 'bundle-text:../img/icons/donut-chart.svg';
import poundSvg from 'bundle-text:../img/icons/circle-pound.svg';
import qrSvg from 'bundle-text:../img/icons/qr-icon.svg';

import "@fontsource/roboto/index.css";

import '../scss/app.scss';
import '../scss/dark.scss';

function toggleMenu(button) {
    button.classList.toggle('transition');
}
// Make toggleMenu available to inline onclick (or refactor to event listeners)
window.toggleMenu = toggleMenu;

document.addEventListener('DOMContentLoaded', async () => {
    const calculatorsContainer = document.getElementById('calculators-container');

    // Resolve URLs so Parcel includes these files and rewrites paths in dist
    const oeeUrl = new URL('../res/partials/oee-calculator.html', import.meta.url);
    const profitUrl = new URL('../res/partials/profit-calculator.html', import.meta.url);

    // Fetch OEE Calculator partial
    try {
        const res = await fetch(oeeUrl);
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        const html = await res.text();
        calculatorsContainer.insertAdjacentHTML('beforeend', html);
    } catch (err) {
        console.error('Failed to load OEE Calculator:', err);
    }

    // Fetch Profit Calculator partial
    try {
        const res = await fetch(profitUrl);
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        const html = await res.text();
        calculatorsContainer.insertAdjacentHTML('beforeend', html);
    } catch (err) {
        console.error('Failed to load Profit Calculator:', err);
    }

    // Init after partials are in the DOM
    const chartColours = ['#77dd77', '#1f6b1f'];

    const canvasEl = document.querySelector('#oee-chart canvas');
    if (!canvasEl) {
        console.warn('OEE chart canvas not found');
        return;
    }

    const oeeChart = new Chart(canvasEl.getContext('2d'), {
        type: 'doughnut',
        data: {
            labels: ['OEE', 'Opportunity'],
            datasets: [{ data: [0, 100], backgroundColor: chartColours }]
        },
        options: {
            rotation: 270,
            circumference: 180,
            cutout: '75%',
            borderWidth: 0,
            plugins: { legend: { display: false }, tooltip: { enabled: false } }
        }
    });

    new OeeCalculator(oeeChart);
    new ProfitCalculator();
});

document.addEventListener('DOMContentLoaded', () => {

    const qrDialogEl = document.getElementById('dialog-qr');
    const qrIconEl = document.getElementById('qr-button');
    const oeeEl = document.querySelector('[data-tool="oee-calculator"]');
    const profitEl = document.querySelector('[data-tool="profit-calculator"]');

    // QR Dialog
    qrIconEl.addEventListener('click', () => {
        qrDialogEl.showModal();
    });
    document.querySelector('.dialog-close').addEventListener('click', () => {
        qrDialogEl.close();
    });

    // Insert SVGs
    if (qrIconEl) qrIconEl.insertAdjacentHTML('afterbegin', qrSvg);
    if (oeeEl) oeeEl.insertAdjacentHTML('afterbegin', donutSvg);
    if (profitEl) profitEl.insertAdjacentHTML('afterbegin', poundSvg);

    // Optional: tag the injected SVGs for styling
    qrIconEl?.querySelector('svg')?.classList.add('icon');
    oeeEl?.querySelector('svg')?.classList.add('icon');
    profitEl?.querySelector('svg')?.classList.add('icon');

});

if (typeof navigator.serviceWorker !== 'undefined') {
    navigator.serviceWorker.register(new URL('./sw.js', import.meta.url))
}